import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams, Redirect
} from "react-router-dom";
import LeaseMenu from "./LeaseMenu";
// import UnitDetailMaster from "./storeDirectory/UnitDetailMaster";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./createLease.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faSignOutAlt,
  faKey,
} from "@fortawesome/free-solid-svg-icons";
import LeaseLandlord from "./parties/LeaseLandlord";
import LeaseOccupier from "./parties/LeaseOccupier";
import LeaseTermDetails from "./criticaldates/LeaseTermDetails";
import LeaseBrokerDetails from "./parties/LeaseBrokerDetails";
import LockInNoticePeriod from "./criticaldates/LockInNoticePeriod";
import RentalDetails from "./commercialDetails/RentalDetails";
import OtherRentalDetails from "./commercialDetails/OtherRentalDetails"
import CamDetails from "./commercialDetails/CamDetails";
import Utilities from "./otherCharges/Utilities";
import MarketingFund from "./otherCharges/MarketingFund";
import PropertyMuncipalTax from "./otherCharges/Property-Muncipal-Tax";
import ParkingStorageSignage from "./otherCharges/Parking-Storage-Signage";
import RentDepositDetails from "./securityDepositDetails/RentDepositDetails";
import CAMDepositDetails from "./securityDepositDetails/CAMDepositDetails";
import OtherDepositDetails from "./securityDepositDetails/OtherDepositDetails";
import CommercialClauses from "./criticalClauses/CommercialClauses";
import OtherClauses from "./criticalClauses/OtherClauses";
import UploadDocument from "./criticalClauses/UploadDocument";
import ListingForm from "./leaseList/ListingForm";
import Prospect from "./prospect/Prospect";
import ProspectDetail from "./prospect/ProspectDetail";
import TopHeader from "../layout/TopHeader";
import SubmitLease from "./submitLease/SubmitLease";
import RentCharge from "./chargeType/RentCharge";





export default function CreateLease() {
  let match = useRouteMatch();

  return (
    <div>
      <TopHeader />
      <div className="masterContainer">
        <div className={window.location.pathname === "/createlease" || window.location.pathname === "/createlease/prospect" ? "" : "masterClassMain mt-4"}>
          {/* <h2>Masters</h2> */}

          {/* The Topics page has its own <Switch> with more routes
            that build on the /topics URL path. You can think of the
            2nd <Route> here as an "index" page for all topics, or
            the page that is shown when no topic is selected */}
          <Switch>

            <Route path={`${match.path}/lease-landlord/:id`}>
              <LeaseMenu openMenu="1" activeKey="1-1" moduleName={`${match.path}`} />
              <LeaseLandlord />
            </Route>

            <Route path={`${match.path}/lease-landlord`}>
              <LeaseMenu openMenu="1" activeKey="1-1" moduleName={`${match.path}`} />
              <LeaseLandlord />
            </Route>

            <Route path={`${match.path}/lease-occupier/:id`}>
              <LeaseMenu openMenu="1" activeKey="1-2" moduleName={`${match.path}`} />
              <LeaseOccupier />
            </Route>

            <Route path={`${match.path}/lease-term-details/:id`}>
              <LeaseMenu openMenu="2" activeKey="2-1" moduleName={`${match.path}`} />
              <LeaseTermDetails />
            </Route>


            <Route path={`${match.path}/lease-broker-details/:id`}>
              <LeaseMenu openMenu="3" activeKey="3-4" moduleName={`${match.path}`} />
              <LeaseBrokerDetails />
            </Route>

            <Route path={`${match.path}/lock-in-notice-period/:id`}>
              <LeaseMenu openMenu="2" activeKey="2-2" moduleName={`${match.path}`} />
              <LockInNoticePeriod />
            </Route>

            <Route path={`${match.path}/rental-details/:id`}>
              <LeaseMenu openMenu="3" activeKey="3-1" moduleName={`${match.path}`} />
              <RentalDetails />
            </Route>

            <Route path={`${match.path}/other-rental-details/:id`}>
              <LeaseMenu openMenu="3" activeKey="3-2" moduleName={`${match.path}`} />
              <OtherRentalDetails />
            </Route>

            <Route path={`${match.path}/cam-details/:id`}>
              <LeaseMenu openMenu="3" activeKey="3-3" moduleName={`${match.path}`} />
              <CamDetails />
            </Route>

            <Route path={`${match.path}/utilities/:id`}>
              <LeaseMenu openMenu="4" activeKey="4-1" moduleName={`${match.path}`} />
              <Utilities />
            </Route>

            <Route path={`${match.path}/marketing-fund/:id`}>
              <LeaseMenu openMenu="4" activeKey="4-2" moduleName={`${match.path}`} />
              <MarketingFund />
            </Route>

            <Route path={`${match.path}/property-muncipal-tax-fund/:id`}>
              <LeaseMenu openMenu="4" activeKey="4-3" moduleName={`${match.path}`} />
              <PropertyMuncipalTax />
            </Route>

            <Route path={`${match.path}/parking-storage-signage/:id`}>
              <LeaseMenu openMenu="4" activeKey="4-4" moduleName={`${match.path}`} />
              <ParkingStorageSignage />
            </Route>

            <Route path={`${match.path}/rent-deposit-details/:id`}>
              <LeaseMenu openMenu="5" activeKey="5-1" moduleName={`${match.path}`} />
              <RentDepositDetails />
            </Route>

            <Route path={`${match.path}/cam-deposit-details/:id`}>
              <LeaseMenu openMenu="5" activeKey="5-2" moduleName={`${match.path}`} />
              <CAMDepositDetails />
            </Route>

            <Route path={`${match.path}/other-deposit-details/:id`}>
              <LeaseMenu openMenu="5" activeKey="5-3" moduleName={`${match.path}`} />
              <OtherDepositDetails />
            </Route>

            <Route path={`${match.path}/commercial-clauses/:id`}>
              <LeaseMenu openMenu="6" activeKey="6-2" moduleName={`${match.path}`} />
              <CommercialClauses />
            </Route>

            <Route path={`${match.path}/other-clauses/:id`}>
              <LeaseMenu openMenu="6" activeKey="6-3" moduleName={`${match.path}`} />
              <OtherClauses />
            </Route>

            <Route path={`${match.path}/upload-document/:id`}>
              <LeaseMenu openMenu="6" activeKey="6-1" moduleName={`${match.path}`} />
              <UploadDocument />
            </Route>



            <Route path={`${match.path}/prospect/view/:id`}>
              <ProspectDetail />
            </Route>

            <Route path={`${match.path}/prospect`}>
              <Prospect />
            </Route>

            <Route path={`${match.path}/charge-rent/:id`}>
                <LeaseMenu openMenu="7" activeKey="7-1" moduleName={`${match.path}`} />
                <RentCharge />
              </Route>

            <Route path={`${match.path}/submit-lease/:id`}>
              <LeaseMenu openMenu="8" activeKey="8-1" moduleName={`${match.path}`} />
              <SubmitLease />
            </Route>

            <Route path={`${match.path}`}>
              <ListingForm />
            </Route>

          </Switch>
        </div>
      </div>
    </div>
  );
}
